import React from 'react'
import classNames from 'classnames'

import {
  errorClass,
  fieldClass,
  fieldClassError,
  getFloatingLabelClass,
  hiddenFields,
  initialFormState
} from '@toasttab/main/src/components/Snowflake/RequestDemo/utils/requestDemoFormUtils'

export type FormState = typeof initialFormState

export type FormFieldProps = {
  label: string
  name: keyof FormState
  type?: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
  onBlur: (e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => void
  error?: string
  touched?: boolean
  maxLength?: number
  className?: string
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
  required?: boolean
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  onBlur,
  error,
  touched,
  maxLength = 255,
  className = '',
  inputProps = {},
  required = false
}) => (
  <div className={`field-wrapper ${name} mb-5 relative`} id={`field-${name}`}>
    <input
      aria-invalid={!!error}
      id={name}
      maxLength={maxLength}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      placeholder=' '
      type={type}
      required={required && name === 'email'}
      value={value ?? ''}
      className={classNames(
        fieldClass,
        { [fieldClassError]: touched && error },
        className
      )}
      {...inputProps}
    />
    <label
      className={getFloatingLabelClass(value, !!touched, error)}
      htmlFor={name}
    >
      {label}
      {required && <span>*</span>}
    </label>
    {touched && error ? <span className={errorClass}>{error}</span> : null}
  </div>
)

export const renderHiddenFields = (form: FormState) =>
  hiddenFields.map((field) => (
    <input
      id={field}
      key={field}
      name={field}
      type='hidden'
      value={form[field as keyof FormState] ?? ''}
    />
  ))

export const formActionUrl = '/?action=marketo-integration/default/post'

export const getFormActionUrl = (formActionURL: string) => {
  let formAction = formActionUrl
  if (
    formActionURL === 'marketo-integration/default/referral' ||
    formActionURL === 'marketo-integration/default/getmarketolead'
  ) {
    const actionURL = formActionUrl.split('?action=')[0]
    formAction = `${actionURL}?action=${formActionURL}`
  }
  if (
    [
      'contentful-dev.phrasingpro3.com',
      'contentful-staging.phrasingpro3.com',
      'contentful-preview-dev.phrasingpro3.com',
      'contentful-preview-staging.phrasingpro3.com'
    ].includes(window.location.hostname)
  ) {
    if (formActionURL === 'marketo-integration/default/referral') {
      formAction = `?action=${formActionURL}`
    }
    let domain = 'https://staging.phrasingpro3.com'
    if (
      ['contentful-staging.phrasingpro3.com'].includes(window.location.hostname)
    ) {
      domain = `https://${window.location.hostname}/`
    }
    formAction = `${domain}${formAction}`
  }
  if (
    [
      'contentful-preview-master.phrasingpro3.com',
      'contentful-pos-proxy.phrasingpro3.com'
    ].includes(window.location.hostname)
  ) {
    formAction = `https://pos.toasttab.com${formAction}`
  }
  return formAction
}
